// src/config.js
const config = {
    // API_URL: 'https://go-condo-api-anfdc5h7fvdydqbs.australiasoutheast-01.azurewebsites.net',//legacy
    API_URL: process.env.REACT_APP_API_URL,//prod
    // API_URL: 'https://go-condo-api-aydxddf9cya0ckdr.southeastasia-01.azurewebsites.net',//prod
    // API_URL: 'https://go-condo-api-np-hge8c3bfe0dga6d2.southeastasia-01.azurewebsites.net',//nprod
    // API_URL: "http://localhost:5000",
    PAYMENT_API_URL: process.env.REACT_APP_PAYMENT_API_URL,
    PAYMENT_PUBLIC_KEY: process.env.REACT_APP_PAYMENT_PUBLIC_KEY,
    // AZURE_STORAGE_CONNECTION_STRING: "DefaultEndpointsProtocol=https;AccountName=gocondostorage;AccountKey=fDaB+eyWBDlywWBbS5VrY6MYJv95QOhZvuXYPMaBLftU9b5BHzsSc7p3pfisStQxLVD5DbR9ICGO+AStVXfKjQ==;EndpointSuffix=core.windows.net"//legacy
    AZURE_STORAGE_CONNECTION_STRING: process.env.REACT_APP_AZURE_STORAGE_CONNECTION_STRING // prod
    // AZURE_STORAGE_CONNECTION_STRING: "DefaultEndpointsProtocol=https;AccountName=gocondoblobstorage;AccountKey=t2v4KsFCsZo6rAjFjlfYSpwt4ZlFetCrsWoTa5wds7cv+tqCk7wkkvbcgLhLYI6Sa17RgONBOCaY+ASt1z11oA==;EndpointSuffix=core.windows.net"//prod
    // AZURE_STORAGE_CONNECTION_STRING: "DefaultEndpointsProtocol=https;AccountName=gocondoblobstoragenp;AccountKey=zAYHekpW5+Cq9cW8fjBFMZUipoqAk+4ybJkNW54Hj17jQ9BHnz1ja0vV2wOzwecK5JkA/9zKegMK+AStHFj3Xw==;EndpointSuffix=core.windows.net"//nprod
};

export default config;
